const PREFIX = 'maintenance-protocol-draft:';

export type ProtocolDraftBuffer = Record<string, { value: unknown; comment?: string | null }>;

export function readProtocolDraft(protocolId: string): ProtocolDraftBuffer {
  try {
    const raw = sessionStorage.getItem(`${PREFIX}${protocolId}`);
    if (!raw) {
      return {};
    }
    return JSON.parse(raw) as ProtocolDraftBuffer;
  } catch {
    return {};
  }
}

export function writeProtocolDraft(protocolId: string, draft: ProtocolDraftBuffer): void {
  sessionStorage.setItem(`${PREFIX}${protocolId}`, JSON.stringify(draft));
}

export function clearProtocolDraft(protocolId: string): void {
  sessionStorage.removeItem(`${PREFIX}${protocolId}`);
}
